import { IOffer } from '../offer';
import { IMakeRequest } from '../utils/request';

export function updateOfferComment(
  makeRequest: IMakeRequest,
  offer: IOffer,
  text: string | undefined,
): Promise<{ status: string }> {
  return makeRequest({
    uri: {
      path: `/ajax/${offer.dealType}/${offer.offerType}/notes`,
    },
    headers: [['Content-Type', 'application/x-www-form-urlencoded']],
    // tslint:disable-next-line:max-line-length
    body: `action=${text ? 'save' : 'delete'}${text ? `&text=${encodeURIComponent(text)}` : ''}&oid=${offer.cianId ||
      offer.id}`,
    method: 'POST',
  }).then((response: { status: string }) => {
    return response;
  });
}

export function updateAgentComment(
  makeRequest: IMakeRequest,
  offer: IOffer,
  text: string | undefined,
): Promise<{ status: string }> {
  return makeRequest({
    uri: {
      path: `/ajax/${offer.dealType}/${offer.offerType}/realtor_notes`,
    },
    headers: [['Content-Type', 'application/x-www-form-urlencoded']],
    // tslint:disable-next-line:max-line-length
    body: `action=${text ? 'save' : 'delete'}${text ? `&text=${encodeURIComponent(text)}` : ''}&rid=${offer.user &&
      offer.user.cianUserId}`,
    method: 'POST',
  }).then((response: { status: string }) => {
    return response;
  });
}
